import React from 'react'
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function Index(props) {
    // Props
    const { searchResults, setShowAutoComplete, setSearchResults, toTitleCase, className = 'absolute left-10 w-fit top-10' } = props
    return (
        <div className='flex flex-col px-3 md:px-0'>
            <ul className={`bg-gray-100 text-gray-600 px-2 py-2 z-50 rounded-b-md shadow space-y-1 ${className} max-h-[500px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100`}>
                {searchResults?.map((moq) => (
                    <li
                        key={moq?.id}
                        className="py-1 px-2 bg-gray-200 hover:bg-[#A68F69] hover:text-white rounded-sm"
                    >
                        <a
                            href={`/products/${moq?.moq_slug}`}
                            onClick={() => {
                                setShowAutoComplete(false)
                                setSearchResults([])
                            }}
                        >
                            <div className="w-full h-fit flex flex-row justify-start items-center p-2 cursor-pointer space-x-5 border-b last:border-b-0">
                                <LazyLoadImage
                                    className="w-10 h-10 border border-gray-400"
                                    src={
                                        moq?.product[0]?.images[0] ||
                                        "https://via.placeholder.com/300"
                                    }
                                    alt={
                                        moq?.product[0]?.name
                                            ? toTitleCase(moq?.product[0]?.name)
                                            : "-"
                                    }
                                />

                                <p className="font-bold capitalize text-base truncate">
                                    {moq?.product[0]?.name
                                        ? toTitleCase(moq?.product[0]?.name)
                                        : "-"}
                                </p>
                            </div>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    )
}
